<template>
  <BaseModalConfirm
    :value="isShowModal"
    :title="$tc('regAuthForgot.passwordSuccessForm.title')"
    :text="$tc('regAuthForgot.passwordSuccessForm.description')"
    :svg="svg"
    :image-alt="$tc('regAuthForgot.passwordSuccessForm.title')"
    no-cancel
    @submit="onSubmit"
    @close="onSubmit"
  >
    <template #controls="{ onSubmit: submitModal }">
      <UiBtn
        color="primary"
        :text="$tc('regAuthForgot.passwordSuccessForm.button')"
        @click="submitModal"
      />
      <BaseSupportButton size="m" />
    </template>
  </BaseModalConfirm>
</template>

<script>
import { AuthBy } from '@/util/composables/useLocalStorage'
import BaseModalConfirm from '~/components/Base/Modal/Confirm'
import BaseSupportButton from '@/components/Base/SupportButton'

export default {
  name: 'ThePasswordChangeSuccessModal',
  components: { BaseModalConfirm, BaseSupportButton },
  props: {
    isShowModal: { type: Boolean },
  },
  data() {
    return {
      svg: {
        name: 'common/check-circle',
        style: 'color: var(--primary-500)',
      },
    }
  },
  methods: {
    onSubmit() {
      this.$router.push({
        path: this.$paths.home,
        query: { bigModal: 'auth', bigModalTab: AuthBy.value || 'email' },
      })
    },
  },
}
</script>
